import React, { useState, useEffect, Suspense } from 'react';
import Login from './Login'
import Ladataan from './Ladataan'
import axios from 'axios';
import PlayerDetails from './PlayerDetails'
import { Redirect, Route, Switch, Link } from 'react-router-dom';
import MyErrorBoundary from './MyErrorBoundary';
import useSound from "use-sound";
import kyselysoundi from "./kyselymusiikki.mp3";

export default function Main(props) {
  var isLoggedIn = false;
  if (localStorage.getItem('access_token') !== null && localStorage.getItem('access_token') !== 'a') {
    isLoggedIn = true;
  }
  const [data, setData] = useState({});
  const [level, setLevel] = useState(0);
  const [loading, setLoading] = useState(false);
  const [levelTries, setLevelTries] = useState(1);
  const [points, setPoints] = useState(0);

  const [isPlaying, setIsPlaying] = useState(false);
  const [playKysely, { stop }] = useSound(kyselysoundi, { loop: true, interrupt: true, volume: 0.1 })

  function nextLevel2(prev) {
    console.log(prev)
    if (prev !== level) return;
    setLoading(true);
    let newLevel = level + 2;
    axios.post(process.env.REACT_APP_API + '/user/level', { level: newLevel }, { headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } })
      .then(res => {
        console.log(res)
        const result = res.data;
        if (result.success && level !== result.level) {
          setLevel(result.level);
          setLevelTries(result.tries)
          setPoints(result.points)
          setLoading(false);

        }
      })
  }

  function nextLevel(prev) {
    console.log(prev)
    if (prev !== level) return;
    setLoading(true);
    let newLevel = level + 1;
    axios.post(process.env.REACT_APP_API + '/user/level', { level: newLevel }, { headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } })
      .then(res => {
        console.log(res)
        const result = res.data;
        if (result.success && level !== result.level) {
          setLevel(result.level);
          setLevelTries(result.tries)
          setPoints(result.points)
          setLoading(false);

        }
      })
  }

  const fetchUserData = () => {
    if (isLoggedIn) {
      axios.get(process.env.REACT_APP_API + '/user/', { headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } })
        .then(res => {
          const result = res.data;
          if (result.success) {
            setData(result.data)
            setLevel(result.data.level)
            setLevelTries(result.data.tries)
            setPoints(result.data.points)
          }
        }).catch(function (error) {
          localStorage.setItem("access_token", "a");
          setData(undefined)
        })
    }
  }

  useEffect(() => {
    fetchUserData();
  }, [])

  useEffect(() => {
    let snowLevels = [33, 36, 52, 55, 112., 115];
    if (snowLevels.includes(level)) {
      props.setDisabledSnow(true)
    } else {
      props.setDisabledSnow(false)
    }
  }, [level])

  useEffect(() => {
    if (level > 24 && level < 31) {
      playKysely();
      setIsPlaying(true);
    } else {
      stop();
      setIsPlaying(false);
    }
  }, [playKysely, stop, level])

  if (isLoggedIn) {
    if (data.discord_username == undefined || loading) {
      return <Ladataan />
    } else {
      const Level = React.lazy(() => import('./levels/' + level + "/index.js"));


      return (<div style={{ zIndex: 1, position: "relative" }}>
        <div className="App">
          <MyErrorBoundary>
            {(level > 24 && level < 30) && <img src={process.env.PUBLIC_URL + '/images/5/vaikea.png'} alt="rikun vaikea kysely" style={{ width: "30%", position: "absolute", top: "-7vw", zIndex: -1 }} />}
            <Suspense fallback={<Ladataan />}>
              <Level data={data} nextLevel={nextLevel} nextLevel2={nextLevel2} level={level} tries={levelTries} setTries={setLevelTries} points={points} fetchUserData={fetchUserData} />
            </Suspense>
            {(level < 25 || level > 29) && <PlayerDetails data={data} points={points} />}
            {(Date.now() / 1000 > 1766606400 && level < 121) &&
              <div className="notification">Vanhojen luukkujen suorittaminen ei ole enää mahdollista.</div>
            }


          </MyErrorBoundary>
        </div>

      </div>
      )
    }

  } else {
    return <Login />
  }

}
